module.exports = __webpack_public_path__ + "img/slk.22375abd.jpg";